export default {
	multi_family: {
		fieldName: "nPeople",
		label: "Number of People",
		iconName: "fa-bed",
		max: 10000,
	},
	mens_dorm: {
		fieldName: "nMensDorm",
		label: "Number of Students",
		iconName: "fa-bed",
		max: 10000,
	},
	womens_dorm: {
		fieldName: "nWomensDorm",
		label: "Number of Students",
		iconName: "fa-bed",
		max: 10000,
	},
	motel: {
		fieldName: "nMotel",
		label: "Number of Rooms",
		iconName: "fa-bed",
		max: 10000,
	},
	elementary_school: {
		fieldName: "nElemSchool",
		label: "Number of Students",
		iconName: "fa-graduation-cap",
		max: 10000,
	},
	junior_high: {
		fieldName: "nJrHigh",
		label: "Number of Students",
		iconName: "fa-graduation-cap",
		max: 10000,
	},
	senior_high: {
		fieldName: "nSrHigh",
		label: "Number of Students",
		iconName: "fa-graduation-cap",
		max: 10000,
	},
	nursing_home: {
		fieldName: "nNursingHome",
		label: "Number of Beds",
		iconName: "fa-bed",
		max: 10000,
	},
	food_service_a: {
		fieldName: "nFoodSvcA",
		label: "Maximum Number of Meals per Hour",
		iconName: "fa-utensils",
		max: 100000,
	},
	food_service_b: {
		fieldName: "nFoodSvcB",
		label: "Maximum Number of Meals per Hour",
		iconName: "fa-utensils",
		max: 100000,
	},
	office_building: {
		fieldName: "nOffice",
		label: "Number of People in Office",
		iconName: "fa-person",
		max: 100000,
	},
	apartment: {
		fieldName: "nAptAsh",
		label: "Number of Students",
		iconName: "fa-bed",
		max: 10000,
	},
}
